export default "__VITE_ASSET__CeQyFZxS__"